import type { ExpressionKey } from './language/en';

/**
 * The message key Keycloak names a rejected password by, mapped to the expression
 * that says it in the user's language.
 * Keycloak sends no rule values with the key, so a message states the rule itself,
 * never the realm's number for it.
 */
export const passwordPolicyErrorExpressions: Partial<Record<string, ExpressionKey>> = {
    invalidPasswordMinLengthMessage: 'error-password-too-short',
    invalidPasswordMaxLengthMessage: 'error-password-too-long',
    invalidPasswordMinLowerCaseCharsMessage: 'error-password-needs-lower-case',
    invalidPasswordMinUpperCaseCharsMessage: 'error-password-needs-upper-case',
    invalidPasswordMinDigitsMessage: 'error-password-needs-digit',
    invalidPasswordMinSpecialCharsMessage: 'error-password-needs-special-character',
    invalidPasswordNotUsernameMessage: 'error-password-same-as-username',
    invalidPasswordNotContainsUsernameMessage: 'error-password-contains-username',
    invalidPasswordNotEmailMessage: 'error-password-same-as-email',
    invalidPasswordHistoryMessage: 'error-password-recently-used',
    invalidPasswordBlacklistedMessage: 'error-password-blacklisted',
    invalidPasswordRegexPatternMessage: 'error-password-pattern',
};
